import { LayoutTemplate } from 'lucide-react'
import type { SplitButtonMenuItem, SplitButtonAdminIndicator } from '../components/SplitButton'
import type { UserContextType } from '../hooks/useUser'

/**
 * Build the templates-related SplitButton props based on the current user's
 * admin status and the platform `templatesVisibleToUsers` flag.
 *
 * - Non-admins with flag OFF get no template menu item (chevron hides).
 * - Admins with flag OFF get the menu item + a red indicator.
 * - Everyone with flag ON gets the menu item, no indicator.
 */
export function buildTemplateSplitButtonProps(
  user: UserContextType,
  onOpenGallery: () => void,
): { menuItems: SplitButtonMenuItem[]; adminIndicator?: SplitButtonAdminIndicator } {
  return {
    menuItems: user.features.templatesVisibleToMe
      ? [
          {
            label: 'Start with a template',
            description: 'Pre-built apps ready to customize',
            icon: <LayoutTemplate className="w-4 h-4" />,
            onClick: onOpenGallery,
          },
        ]
      : [],
    adminIndicator:
      user.isAdmin && !user.features.templatesVisibleToUsers
        ? { active: true, tooltip: 'Templates are hidden from regular users — only admins and allowlisted testers see them' }
        : undefined,
  }
}
